/**
 * 
 * @param {{ text: string, style: object, children: ReactNode | null, animated: boolean, variant: "default" | "question" }} props 
 * @returns 
 */
export default function QuestionTextContainer({ text, style, children = null, animated = false, variant = "default" }) {
    const isQuestion = variant === "question";
    return (
        <div className={`w-full flex flex-col items-center gap-3${animated ? ' pulse-once' : ''}`}>
            <div className="TextboxContainer" style={style}>
                <div
                    className="Textbox question-text overflow-y-auto styled-scrollbar"
                    style={{ minHeight: isQuestion ? "11rem" : "7rem" }}
                >
                    <div>{text}</div>
                    {children}
                </div>
            </div>
        </div>
    );
}